import { post, get } from 'api/methods';

import { ApiName } from 'enuns/Api';
import { AssembleiaTipoOrigem } from 'enuns/AssembleiaOrigem';
import { PresencaDadaPor } from 'enuns/Presenca';

export interface PresencaElement {
  colaborador: boolean;
  cooperativa: string;
  cpfCnpj: string;
  dataHoraPresenca: string;
  nomeConvocado: string;
  presencaConfirmada: string;
  numeroConta: string;
  saldoCotas: number;
  flgOrigem: AssembleiaTipoOrigem;
  tr: PresencaDadaPor;
}

export interface PresencaResponse {
  elements: Array<PresencaElement>;
  totalElements: number;
  totalPages: number;
}

export interface PresencaRequest {
  colaborador?: boolean;
  coops?: Array<string>;
  cpfOrNome?: string;
  data?: string;
  idAssembleia: number;
  page: number;
  size: number;
}

export default {
  list: (data: PresencaRequest) => {
    const endpoint = 'presenca/page';
    return post<PresencaResponse>(ApiName.Assessor, endpoint, data);
  },
  cooperativas: (idAssembleia: number) => {
    const endpoint = `assembleia/${idAssembleia}/cooperativas`;
    return get<string[]>(ApiName.Assessor, endpoint);
  },
  relatorio: (data: PresencaRequest) => {
    const endpoint = 'relatorio/presencas';
    return post<ArrayBuffer>(ApiName.Assessor, endpoint, data, {
      responseType: 'arraybuffer',
      headers: {
        'Access-Control-Allow-Headers': 'Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With',
      },
    });
  },
};
